import {
  ALLOWED_EINVOICE_LIST_BILL_TYPES,
  DEFAULT_EINVOICE_LIST_BILL_TYPES,
  normalizeBillTypes,
  normalizeBillTypesOrDefault,
} from '@/core/services/store/modules/einvoice/einvoice.contract'
import { BILL_TYPE_NAME } from '@/utils/enum-name'

export const BILL_TYPE_FILTER_EMPTY_BLOCKED_REASON = 'Cần chọn ít nhất một loại hóa đơn.'

export function buildBillTypeFilterOptions() {
  const optionOrder = [
    ...DEFAULT_EINVOICE_LIST_BILL_TYPES,
    ...ALLOWED_EINVOICE_LIST_BILL_TYPES.filter(
      (billType) => !DEFAULT_EINVOICE_LIST_BILL_TYPES.includes(billType),
    ),
  ]

  return optionOrder.map((billType) => ({
    value: billType,
    text: BILL_TYPE_NAME[billType],
  }))
}

export function normalizeBillTypeFilterSelection(value) {
  return normalizeBillTypesOrDefault(value, DEFAULT_EINVOICE_LIST_BILL_TYPES)
}

export function normalizeBillTypeFilterSelectionSingle(value) {
  const first = Array.isArray(value) ? value[0] : value
  const normalized = first != null ? normalizeBillTypes([first]) : []
  return normalized.length ? normalized : [DEFAULT_EINVOICE_LIST_BILL_TYPES[0]]
}

export function selectBillTypeFilterSingle(billType) {
  return {
    billTypes: normalizeBillTypes([billType]),
    blockedReason: null,
  }
}

export function toggleBillTypeFilterSelection(currentSelection = [], billType) {
  const current = normalizeBillTypeFilterSelection(currentSelection)
  const normalizedTarget = normalizeBillTypes([billType])[0]
  const hasTarget = current.includes(normalizedTarget)
  const nextRaw = hasTarget
    ? current.filter((value) => value !== normalizedTarget)
    : [...current, normalizedTarget]

  if (!nextRaw.length) {
    return {
      billTypes: current,
      blockedReason: BILL_TYPE_FILTER_EMPTY_BLOCKED_REASON,
    }
  }

  return {
    billTypes: normalizeBillTypes(nextRaw),
    blockedReason: null,
  }
}
